import React from 'react'
import { View, useWindowDimensions } from 'react-native'
import WebHeader from '../../../components/WebHeader.js'
import ChangePassword from '../../../screens/authScreens/changePassword/index.web'
import { gradientBackground } from '../../../utils'
import { commonStyles } from '../../../utils/commonStyles'

export default function ChangePasswordContainer({ navigation }) {

    const dimensions = useWindowDimensions();
    const isLargeScreen = dimensions.width >= 768;

    return (
        <View style={commonStyles.mainContainer} key={'MainContainer'}>
            {gradientBackground()}
            <WebHeader navigation={navigation} titles={["Change Password"]} />

            <View style={commonStyles.webSubContainerStyle} key={'SubContainer'}>
                <View style={[commonStyles.webBorderViewStyle, { width: isLargeScreen ? '50%' : '90%' }]} key={'BorderView'}>
                    <View style={{ flex: 1 }}>
                        <ChangePassword navigation={navigation} />
                    </View>
                </View>
            </View>
        </View>
    )
}





